// The SOLUTION GROUPS a picked ManufacturingLineList shows -- what one solution card actually is.
//
// A manufacturing line list makes the WHOLE section, and it makes each PART independently (a shirt box's Kapak on
// one manufacturing line, its Kutu on another). So one card is one solution PER PART, drawn from the CARTESIAN
// PRODUCT across the parts -- every complete way to make the section:
//     one part  -> [[s1], [s2], ...]                 (a group of one; every solution is already whole)
//     two parts -> [[kapak1, kutu1], [kapak1, kutu2], ...]
//
// Ranked cheapest COMBINED first -- the sum of the parts' scores, which is the same total the group card carries as
// data-score. The product grows as solutions ** parts (a Cover of 35 and a Box of 30 is already 1,050 cards, each
// with its layouts drawn), so the grid shows only the `maximumGroups` cheapest (SystemParam
// frank_maximum_solution_groups), found without building the product (cheapestCombinations). Every solution is
// still scored -- the score arrives with the solution -- so the cheapest group is always among them.
//
// The maximum keeps the CHEAPEST, and the cost ordering is not neutral about what it leaves out. A die-cutting
// layout that holds more pieces gangs up less on the printing machine, so it is dearer and ranks worse (on the
// Cover + Box carton of drawing 51517 the one-pass die-cut == print options ran from cost-rank 2 for a 2-up to rank
// 35 for a 36-up). And because it applies to the finished list rather than to each part, a part with one clearly
// cheapest solution can appear in every card while only the other parts vary. When an arrangement is reported
// missing, raise the SystemParam.

import { cheapestCombinations } from 'components/frank/utils/cheapestCombinations.js';

// lower is better: the score is a cost. A missing score sorts last.
const scoreOf = (solution) => (solution.score_data ? solution.score_data.score : Infinity);

// perPart        - one array of solutions per part (the solutions each survive de-duplication and carry their
//                  own score_data.score).
// maximumGroups  - how many groups, cheapest first, the grid shows.
//
// Returns the groups, each an array holding one solution per part.
export const combineSolutionGroups = (perPart, maximumGroups) => (
  cheapestCombinations(perPart, scoreOf, maximumGroups)
);
